"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const math = require("mathjs");
const u = require("../globals/uris");
const _ = require("lodash");
var ExpressionTools;
(function (ExpressionTools) {
    //mjs-function, mjs-op, uri, logicjs
    let opDefs = [
        ["equal", "==", u.EQUAL_TO, "logic.eq"],
        ["larger", ">", u.GREATER_THAN, "logic.eq"],
        ["smaller", "<", u.LESS_THAN, "logic.less_equal"],
        ["add", "+", u.ADDITION, "logic.add"],
        ["subtract", "-", u.SUBTRACTION, "logic.sub"],
        ["multiply", "*", u.MULTIPLICATION, "logic.mul"],
        ["divide", "/", u.DIVISION, "logic.div"],
        ["unaryMinus", "-", undefined, undefined],
        ["pow", "^", u.POWER, undefined]
    ];
    let funcToOp = {};
    opDefs.forEach(o => funcToOp[o[0]] = o[1]);
    let funcToUri = {};
    opDefs.forEach(o => funcToUri[o[0]] = o[2] ? o[2] : funcToUri[o[0]]);
    let uriToFunc = _.invert(funcToUri);
    let opToLogicjs = {};
    opDefs.forEach(o => opToLogicjs[o[1]] = o[3] ? o[3] : opToLogicjs[o[1]]);
    function toUri(mathjsFunction) {
        return funcToUri[mathjsFunction];
    }
    ExpressionTools.toUri = toUri;
    function toOperatorNode(uri, args) {
        return createOperatorNode(uriToFunc[uri], args);
    }
    ExpressionTools.toOperatorNode = toOperatorNode;
    function createOperatorNode(nodeType, args) {
        return new math.expression.node.OperatorNode(toMathjsOp(nodeType), nodeType, args);
    }
    ExpressionTools.createOperatorNode = createOperatorNode;
    function toLogicJsOperatorString(operatorNode) {
        return opToLogicjs[operatorNode.op];
    }
    ExpressionTools.toLogicJsOperatorString = toLogicJsOperatorString;
    /** weirdly mathjs doesn't seem to offer this */
    function toMathjsOp(mathjsFunc) {
        return funcToOp[mathjsFunc];
    }
})(ExpressionTools = exports.ExpressionTools || (exports.ExpressionTools = {}));



//////////////////
// WEBPACK FOOTER
// ./~/dymo-core/lib/math/expressiontools.js
// module id = 270
// module chunks = 3